import React, {useEffect, useState} from "react";
import API from "../../api/axios";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";

export default function VerifyStartVerification() {
    const [logo, setLogo] = useState("/logo.png");
    const [agree, setAgree] = useState(false);
    const { id } = useParams();
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const logoParam = params.get("logo");
        if (logoParam) {
            setLogo(logoParam);
        }

        const storedLogo = localStorage.getItem("logo");
        const finalLogo = storedLogo || "/logo.png";
        setLogo(finalLogo);


    }, []);





    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-[#F7EBFC] px-4 pt-8" >
            <img src={logo} alt="" srcset="" className="max-w-[200px] w-full mb-6"/>
            <form
                className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md border border-[#E3BCF4]"
            >
                <div className="flex justify-center items-center gap-4 mb-4">
                    <div className="text-center">
                        <img src="/credit-card-icon.png" alt="Credit Card" className="mx-auto h-21 mb-1" />
                    </div>
                    <p className="font-bold text-[#652F9B]">OR</p>
                    <div className="text-center">
                        <img src="/photo-id-icon.png" alt="Photo ID" className="mx-auto h-21 mb-1" />
                    </div>
                </div>
                <div className="text-sm sm:text-base text-left mb-6 text-[#652F9B]">
                    <div>✓ Verify yourself once with credit card or ID<br></br><br></br></div>
                    <div>✓ Instant access to multiple 18+ websites. Simple, secure,private<br></br><br></br></div>
                    <div>✓ 100% Confidential verification processed using AI<br></br><br></br></div>
                    <div>✓ Skip Verification on other websites using your login<br></br><br></br></div>
                    <div>✓️ Cancel anytime<br></br><br></br></div>
                    <div>✓ 18verified LTD shown on bank statements<br></br></div>
                </div>
                <div className="text-sm sm:text-base text-center mb-6 text-[#652F9B]">
                <a href={'https://verify.18verified.com/pay/' + id} target="_blank" rel="noopener noreferrer" className="mt-6 w-full bg-[#8E29CD] hover:bg-[#8E29CD] text-white font-medium py-2 rounded-lg transition duration-200">&nbsp;&nbsp;Start Verification&nbsp;&nbsp;</a>
                </div>
            </form>

        </div>
    );
}
